export default __webpack_public_path__ + "static/char-s-58-ja-799648858f4b5dfa279abd507b3531f6.webp";